<template>
  <div>
    <el-card>
      <nav class="out">
        <nav class="input">
          <el-input v-model="form_2.keyword" size="medium" placeholder="请输入姓名，手机，邮箱，职位，备注" />
        </nav>
        <nav class="input">
          <el-input v-model="form_2.company" size="medium" placeholder="请输入公司名称" />
        </nav>
<!--        <nav class="input"  style="width: 220px">-->
<!--          <el-select-->
<!--              style="width: 220px"-->
<!--              v-model="category" placeholder="身份筛选" size="medium"-->
<!--              multiple-->
<!--          >-->
<!--            <el-option label="普通用户" value="0" />-->
<!--            <el-option label="演讲嘉宾" value="2" />-->
<!--            <el-option label="企业高管" value="1" />-->
<!--            <el-option label="海外用户" value="5" />-->
<!--          </el-select>-->
<!--        </nav>-->
        <nav class="input" style="width: 220px">
          <el-select
              style="width: 220px"
              v-model="form_2.completeInfo" placeholder="完善状态" size="medium"
          >
            <el-option label="全部" value="0" />
            <el-option label="已完善" value="2" />
            <el-option label="未完善" value="1" />
          </el-select>
        </nav>
        <nav class="input" style="width: 220px">
          <improve-personnel :value.sync="form_2.amId"></improve-personnel>
        </nav>
        <nav class="input" style="width: 220px">
          <el-select
              style="width: 220px"
              v-model="form_2.register" placeholder="是否注册" size="medium"
          >
            <el-option label="全部" value="0" />
            <el-option label="已注册" value="2" />
            <el-option label="未注册" value="1" />
          </el-select>
        </nav>
        <nav class="input" style="width: 600px">
          <el-select style="width: 180px;margin-right: 30px" v-model="form_2.type" placeholder="行业类型" size="medium">
            <el-option label="全部" :value="-1" />
            <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
          <el-select style="width: 180px;margin-right: 30px" v-model="form_2.business" placeholder="行业" size="medium">
            <el-option label="全部" :value="-1" />
            <el-option v-for="item in businessList" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
          <el-select style="width: 180px;" v-model="form_2.subBusiness" placeholder="二级行业" size="medium">
            <el-option label="全部" :value="-1" />
            <el-option v-for="item in subBusinessList" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </nav>
        <nav class="input" style="width: 340px">
          <el-select
              v-model="form_2.province"
              placeholder="省份"
              size="medium"
              style="width: 150px;margin-right: 20px"
              class="ml"
              @change="getc(form_2.province)"
          >
            <el-option label="全部" :value="-1" />

            <el-option v-for="item in p_arr" :key="item.code" :label="item.name" :value="item.code" />
          </el-select>
          <el-select v-model="form_2.city" placeholder="城市" size="medium" style="width: 150px" class="ml">
            <el-option label="全部" :value="-1" />
            <el-option v-for="item in c_arr" :key="item.code" :label="item.name" :value="item.code" />
          </el-select>
        </nav>
        <nav class="input" style="width: 220px">
          <el-select v-model="form_2.waId" placeholder="小助手" size="medium">
            <el-option label="全部" :value="-1" />
            <el-option label="已绑定小助手" :value="-2" />
            <el-option label="未绑定小助手" :value="-3" />
            <el-option
                v-for="item in $store.state.NormalList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
            />
          </el-select>
        </nav>

        <nav class="input" style="width: 150px">
          <el-select v-model="form_2.bindEnterprise" placeholder="绑定企业" size="medium">
            <el-option label="全部" :value="-1" />
            <el-option label="未绑定" :value="0" />
            <el-option label="已绑定" :value="1" />
          </el-select>
        </nav>

        <nav class="input" style="width: 300px;">
          <el-date-picker
              v-model="form_2.updateTime"
              type="daterange"
              range-separator="至"
              start-placeholder="更新开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              style="width: 100%;margin-left: 10px;"
              size="medium"
          />
        </nav>
        <nav class="input " style="width: 300px;">
          <el-date-picker
              v-model="form_2.completeTime"
              type="daterange"
              range-separator="至"
              start-placeholder="完善开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              style="width: 100%;margin-left: 10px;"
              size="medium"
          />
        </nav>

        <nav class="input " style="width: 300px;">
          <el-date-picker
              v-model="form_2.createTime"
              type="daterange"
              range-separator="至"
              start-placeholder="创建开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              style="width: 100%;margin-left: 10px;"
              size="medium"
          />
        </nav>
        <nav class="input" style="width: 400px">
          <el-select style="width: 400px" v-model="form_2.jobLevel" multiple placeholder="职级" size="medium">
            <el-option
                v-for="(item, index) in $store.state.config && $store.state.config.userJobLevel"
                :key="index"
                :label="item"
                :value="index"
            />
          </el-select>
        </nav>

        <!--              TODO 独立模块-->
        <!--                <nav class="input" style="width: 65px">-->
        <!--                    <el-button-->
        <!--                        v-show="$store.state.btn_if.indexOf('user_guest_down_excel') != -1"-->
        <!--                        type="primary"-->
        <!--                        size="small"-->
        <!--                        @click="beforedown"-->
        <!--                        >{{ btn ? "导出Excel" : "导出中.." }}</el-button-->
        <!--                    >-->
        <!--                </nav>-->


        <!--                <nav class="input" style="width: auto;margin-right: 10px;">-->
        <!--                    <el-button type="primary" size="small" @click="$refs.pop.show = true">同步注册信息</el-button>-->
        <!--                </nav>-->
        <!--                <nav class="input" style="width: auto">-->
        <!--                    <el-button type="primary" :loading="syncEnterpriseLoad" size="small" @click="syncEnterprise"-->
        <!--                        >同步企业信息</el-button-->
        <!--                    >-->
        <!--                </nav>-->
        <nav class="input" style="width: auto">
          <nav class="input" style="width: auto;margin-right: 30px;">
            <el-button size="small" @click="reset">重置</el-button>
            <el-button type="primary" size="small" @click="subimt">{{ "搜索" }}</el-button>
          </nav>

          <el-button
              style="margin: 0px 5px"
              plain
              v-show="$store.state.btn_if.indexOf('user_guest_import_excel') != -1"
              type="primary"
              size="small"
              @click="Import"
          >{{ impEX }}</el-button
          >
<!--          <el-button-->
<!--              style="margin: 0px 5px"-->
<!--              plain-->
<!--              v-show="$store.state.btn_if.indexOf('user_guest_redundant') != -1"-->
<!--              type="primary"-->
<!--              size="small"-->
<!--              @click="show_s"-->
<!--          >{{ reveal ? "显示冗余数据" : "隐藏冗余数据" }}</el-button-->
<!--          >-->
          <!--                  <el-button plain-->
          <!--                             style="margin: 0px 5px"-->
          <!--                             type="primary" size="small" @click="$refs.sendSms.init(form_2)">-->
          <!--                    添加到短信收件人-->
          <!--                  </el-button>-->
          <router-link to="/user_guest_edit">
            <el-button
                style="margin: 0px 5px"
                plain
                v-show="$store.state.btn_if.indexOf('user_guest_add') != -1"
                type="primary"
                size="small"
            >添加用户</el-button>
          </router-link>
          <el-button
              style="margin: 0px 5px"
              type="primary" plain size="small" @click="$refs.helperStatistics.init()">小助手统计</el-button>
<!--          <el-button-->
<!--              style="margin: 0px 5px"-->
<!--              type="primary" plain size="small" v-if="isDerive"  @click="handleDerived">导出</el-button>-->
        </nav>
      </nav>
    </el-card>
    <el-dialog title="" :visible.sync="dioA" width="30%" @close="">
      <Show @form="checkf" />
      <span slot="footer">
                <el-button @click="dioA = false">取消</el-button>
                <el-button type="primary" @click="download">{{ btn ? "导出" : "导出中.." }}</el-button>
            </span>
    </el-dialog>

    <el-card style="margin-top: 10px; font-size: 14px">
      <div style="display: flex;justify-content: space-between;align-items: center">
        <div>
          <nav class="input" style="width: 120px;height: 10px" >
            <el-tooltip  class="item" effect="dark" content="此统计通过对用户数据按手机号进行分组，统计每个唯一手机号对应的用户数量" placement="top">
              <el-badge :value="total_form.totalCount" class="item" type="success">
                已筛选数量
              </el-badge>
            </el-tooltip>

          </nav>
          <nav class="input" style="width: 80px;margin-left:10px;height: 10px">
            <el-tooltip  class="item" effect="dark" content="此统计表示系统中记录的所有内部用户的总数，包括可能存在的重复手机号" placement="top">
              <el-badge :value="total_form.allTotal" class="item" type="primary">
                总数量
              </el-badge>
            </el-tooltip>

          </nav>
          <!--            <nav class="input" style="width: 150px;margin-left:10px;height: 10px">-->
          <!--              <el-badge :value="total_form.existPhoneTotal"  class="item" type="primary">-->
          <!--                手机号不为空总数量-->
          <!--              </el-badge>-->
          <!--            </nav>-->
          <nav class="input" style="width: 150px;margin-left:10px;height: 10px">
            <el-badge :value="total_form.emptyPhoneTotal"  class="item" type="danger">
              手机号为空总数量
            </el-badge>
          </nav>
        </div>
        <nav class="input" style="width: auto">
          <el-button
              :loading="importExcel"
              v-show="$store.state.btn_if.indexOf('overseas_import_excel') != -1"
              type="text"
              size="small"
              icon="el-icon-upload"
              @click="onDownload"
          >{{ "下载导入Excel模板" }}</el-button
          >
        </nav>
      </div>
      <el-table
          :data="reveal ? list : table"
          style="width: 100%"
          border
          stripe
          :header-cell-style="rowClass"
          @sort-change="sortChange"
      >

        <el-table-column prop="id" width="100"  label="ID/身份">
          <template slot-scope="{ row }">
            <div>
              {{ row.id }}
            </div>
            <div v-if="row.register">
              <el-tag style="margin-top: 10px" size="mini" >已注册</el-tag>

            </div>
<!--            <div v-if="row.category">-->
<!--              <div v-for="i in row.category.toString().split(',')">-->
<!--                <el-tag v-if="i == 1" type="success" size="mini"  > 企业高管</el-tag>-->
<!--                <el-tag v-if="i == 2" type="warning" size="mini"  > 演讲嘉宾</el-tag>-->
<!--                <el-tag v-if="i == 5" type="warning" size="mini"  > 海外用户</el-tag>-->
<!--              </div>-->
<!--            </div>-->


          </template>
        </el-table-column>
        <el-table-column prop="completeInfo" label="状态">
          <template slot-scope="{ row }">
            <div  style="display: flex;align-items: center;flex-direction: column;justify-content: center">
              <el-tooltip  class="item" effect="dark" content="填写了【姓名/公司/行业类型/一级行业/省份/城市】即代表已完善" placement="top">
                <el-tag  type="warning" v-if="row.completeInfo == 1">已完善</el-tag>
                <el-tag  type="info" v-if="row.completeInfo == 0">未完善</el-tag>
              </el-tooltip>

              <el-tooltip  class="item" effect="dark" content="表示这条数据在【注册用户】也存在" placement="top">
                <el-tag style="margin-top: 10px" type="info" v-if="row.repeat == 1">重复数据</el-tag>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="realName" width="150" label="姓名">
          <template slot-scope="{ row }">
            <el-image v-if="row.category == 2 && row.avatar" :src="row.avatar" style="width: 50px"></el-image><br>


            <div class="flex-center">

              <span style="margin-right: 5px">{{ row.realName }}</span>
              <el-tooltip v-if="row.category == 2" class="item" effect="dark" :content="row.desc" placement="top">
                <img style="width: 12px;
                                height: 12px;margin: 0px 5px 0px 0px "
                     src="https://cdn-img.yfchuhai.com/www.yfchuhai.com/static/pc/img/vip_img/question_mark.png"
                     alt="">
              </el-tooltip>
              <el-tag type="danger" size="mini" effect="dark" @click="unfold(row)"> {{ row.num }}</el-tag>
              <!--                        <div style="margin-top: 5px;margin-left: 5px">-->
              <!--                          <el-tag v-if="fUser(row)" size="small" :type="fUserColor(row)">-->
              <!--                            {{ fUser(row) }}-->
              <!--                          </el-tag>-->
              <!--                        </div>-->
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="cityName" label="城市" width="130px">
          <template slot-scope="{ row }">
                        <span>{{ row.provinceName }}</span
                        >
            <span v-if="row.cityName && row.provinceName">
                    -
                  </span><span >{{ row.cityName }}</span>
            <span v-if="row.address && row.cityName">
-
                  </span>
            <span v-if="row.address">
                        {{row.address}}
                      </span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="desc" label="简介"> </el-table-column> -->
        <el-table-column prop="company" width="150" label="公司">
          <template slot-scope="{ row }">
            <p>{{ row.company }}</p>
            <el-tooltip  class="item" effect="dark" content="已绑定到企业库，如需修改企业信息请到企业管理修改" placement="top">
              <el-tag v-if="row.enterpriseId > 0" size="small" type="warning">
                {{ fEnterpriseId(row) }}
              </el-tag>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="job" label="职务对外名称"> </el-table-column> -->

        <el-table-column prop="type" label="类型/行业" width="200">
          <template slot-scope="{ row }">
            <div v-if="row.typeName" class="margin5px"> <el-tag type="info">{{ row.typeName }}</el-tag></div>
            <div v-if="row.businessName" class="margin5px"><el-tag  type="info">{{ row.businessName }}</el-tag></div>
            <div v-if="row.subBusinessName" class="margin5px"><el-tag  type="info">{{row.subBusinessName}}</el-tag></div>

          </template>
        </el-table-column>
        <el-table-column prop="job" label="职位" width="130">
          <template slot-scope="{ row }">
            <span v-if="$store.state.btn_if.indexOf('user_guest_remark') == -1"> {{ row.job }}</span>
            <Remark
                v-else
                rowKey="job"
                :row="row"
                url="/admin/UserGuest/editInfo"
                @getlist="getlist(row)"
            ></Remark>
          </template>
        </el-table-column>
        <el-table-column prop="jobLevelName" label="级别" width="140">
          <template #header>
                        <span style="display: inline-flex; align-items: center;">
                            <img style="width: 20px; height: 20px; margin-right: 4px;"
                                src="https://cdn-img.yfchuhai.com/www.yfchuhai.com/static/pc/img/ai-icon.png" alt="">
                            级别
                        </span>
                    </template>
          <template slot-scope="{ row }">
            <el-select v-model="row.jobLevel" @change="S_jobLevel(row)">
              <el-option
                  v-for="(item, index) in $store.state.config.userJobLevel"
                  :key="index"
                  :label="item"
                  :value="index * 1"
              />
            </el-select>
          </template>
        </el-table-column>


        <el-table-column prop="remark" label="备注" width="140" >
          <template #header>
                        <span style="display: inline-flex; align-items: center;">
                            <img style="width: 20px; height: 20px; margin-right: 4px;"
                                src="https://cdn-img.yfchuhai.com/www.yfchuhai.com/static/pc/img/ai-icon.png" alt="">
                            备注
                        </span>
                    </template>
          <template slot-scope="{ row }">
            <!-- <div class="input-box">
                <el-input v-show="row.pai" v-model="row.remark" size="small" class="id" :autofocus="row.pai" @blur="handleInputBlur(row)" />
            </div>
            <span v-show="!row.pai" @click="$store.state.btn_if.indexOf('user_guest_remark') != -1 && showinput(row)"> {{ row.remark }}</span>
            <i
                v-show="!row.pai"
                :class="$store.state.btn_if.indexOf('user_guest_remark') != -1 && 'el-icon-edit'"
                @click="$store.state.btn_if.indexOf('user_guest_remark') != -1 && showinput(row)"
            /> -->
            <Remarks
                v-if="$store.state.btn_if.indexOf('overseas_remark') != -1"
                :row="row"
                url="/admin/UserGuest/editRemark"
                @getlist="getlist"
                :val="{ url: '/admin/UserGuest/editRemark', pw: 'overseas_remark', user:'是否将备注同步注册用户' }"

            ></Remarks>
            <span v-else>{{ row.remark }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="activityName" label="活动"> </el-table-column> -->
        <el-table-column prop="waId" label="小助手" width="120">
          <template slot-scope="{ row }">
            <div>
              <el-select
                  v-model="row.waId"
                  placeholder="小助手"
                  multiple
                  :multiple-limit="3"
                  size="medium"
                  :disabled="!QX('overseas_assistant')"
                  @change="chagne(row)"
                  @visible-change="visibleChange"
                  @remove-tag="handleRemove"
              >
                <el-option
                    v-for="item in $store.state.NormalList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id + ''"
                />
              </el-select>

              <Remarks
                  style="margin-top: 20px"
                  :row="row"
                  :rowKey="'crowd'"
                  url="/admin/UserGuest/editCrowd"
                  @getlist="getlist"
                  :val="{ url: '/admin/UserGuest/editCrowd',pw:'user_guest_assistant', user:'是否将备注同步注册用户' }"

              ></Remarks>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="最近更新" width="250">
          <template slot-scope="{ row }">
            <p v-if="row.updateTime">最近更新：{{ row.updateTime  }}</p>
            <p v-if="row.completeInfoTime">完善时间：{{ row.completeInfoTime  }}</p>
            <p v-if="row.createTime">添加时间：{{ row.createTime   }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="活动" width="210">
          <template slot-scope="{ row }">
            <el-tag
                v-for="item in !!row.activityName && row.activityName.split(',')"
                :key="item"
                type="info"
                size="mini"
                effect="dark"
            >{{ item }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150"  fixed="right">
          <template slot-scope="ew">
            <router-link :to="'/user_guest_edit?id=' + ew.row.id">
              <el-button

                  v-show="$store.state.btn_if.indexOf('user_guest_edit') != -1"
                  type="text"
                  icon="el-icon-edit"
                  size="mini"
                  class="skyblue"
                  @click="edit(ew.row.id)"
              >编辑</el-button
              >
            </router-link>

            <el-button
                style="margin-left:10px"
                v-show="$store.state.btn_if.indexOf('user_guest_del') != -1"
                type="text"
                icon="el-icon-delete"
                size="mini"
                class="red"
                @click="open(ew.row.id, 1)"
            >删除</el-button
            >
            <el-button
                v-show="$store.state.btn_if.indexOf('overseas_show') != -1"
                type="text"
                size="mini"
                icon="el-icon-camera"
                class="green"
                @click="information(ew.row)"
            >查看联系方式</el-button
            >
            <el-button
                v-if="ew.row.enterpriseId > 0"
                type="text"
                icon="el-icon-s-release"
                size="mini"
                @click="solutionEnterprise(ew.row)"
            >解绑企业</el-button
            >
            <el-button
                type="text"
                size="mini"
                v-if="ew.row.document"
                icon="el-icon-download"
                class="yellow"
                @click="datum(ew.row)"
            >资料下载</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
          v-show="reveal"
          :current-page="form_2.page"
          background
          :page-sizes="[3, 5, 10, 15]"
          :page-size="pagesize"
          layout="total, prev, pager, next,jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
      />
      <el-pagination
          v-show="!reveal"
          :current-page="currentPage2"
          background
          :page-sizes="[3, 5, 10, 15]"
          :page-size="pagesize"
          layout="total, prev, pager, next,jumper"
          :total="total2"
          @current-change="handleCurrentChange2"
      />
    </el-card>

    <el-dialog title="" :visible.sync="phone_data" width="80%">
      <el-table
          :data="phonelist"
          style="width: 100%"
          border
          stripe
          :header-cell-style="rowClass"
          @sort-change="sortChange"
      >

        <el-table-column prop="id" width="100"  label="ID/身份">
          <template slot-scope="{ row }">
            <div>
              {{ row.id }}
            </div>
            <div v-if="row.register">
              <el-tag style="margin-top: 10px" size="mini" >已注册</el-tag>

            </div>
            <div v-if="row.category">
              <div v-for="i in row.category.toString().split(',')">
                <el-tag v-if="i == 1" type="success" size="mini"  > 企业高管</el-tag>
                <el-tag v-if="i == 2" type="warning" size="mini"  > 演讲嘉宾</el-tag>
              </div>
            </div>


          </template>
        </el-table-column>
        <el-table-column prop="completeInfo" label="状态">
          <template slot-scope="{ row }">
            <div  style="display: flex;align-items: center;flex-direction: column;justify-content: center">
              <el-tooltip  class="item" effect="dark" content="填写了【姓名/公司/行业类型/一级行业/省份/城市】即代表已完善" placement="top">
                <el-tag  type="warning" v-if="row.completeInfo == 1">已完善</el-tag>
                <el-tag  type="info" v-if="row.completeInfo == 0">未完善</el-tag>
              </el-tooltip>

              <el-tooltip  class="item" effect="dark" content="表示这条数据在【注册用户】也存在" placement="top">
                <el-tag style="margin-top: 10px" type="info" v-if="row.repeat == 1">重复数据</el-tag>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="realName" width="150" label="姓名">
          <template slot-scope="{ row }">
            <el-image v-if="row.category == 2 && row.avatar" :src="row.avatar" style="width: 50px"></el-image><br>


            <div class="flex-center">

              <span style="margin-right: 5px">{{ row.realName }}</span>
              <el-tooltip v-if="row.category == 2" class="item" effect="dark" :content="row.desc" placement="top">
                <img style="width: 12px;
                                height: 12px;margin: 0px 5px 0px 0px "
                     src="https://cdn-img.yfchuhai.com/www.yfchuhai.com/static/pc/img/vip_img/question_mark.png"
                     alt="">
              </el-tooltip>

            </div>
          </template>
        </el-table-column>
        <el-table-column prop="cityName" label="城市" width="130px">
          <template slot-scope="{ row }">
                        <span>{{ row.provinceName }}</span
                        >
            <span v-if="row.cityName && row.provinceName">
                    -
                  </span><span >{{ row.cityName }}</span>
            <span v-if="row.address && row.cityName">
-
                  </span>
            <span v-if="row.address">
                        {{row.address}}
                      </span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="desc" label="简介"> </el-table-column> -->
        <el-table-column prop="company" width="150" label="公司">
          <template slot-scope="{ row }">
            <p>{{ row.company }}</p>
            <el-tooltip  class="item" effect="dark" content="已绑定到企业库，如需修改企业信息请到企业管理修改" placement="top">
              <el-tag v-if="row.enterpriseId > 0" size="small" type="warning">
                {{ fEnterpriseId(row) }}
              </el-tag>
            </el-tooltip>

          </template>
        </el-table-column>
        <!-- <el-table-column prop="job" label="职务对外名称"> </el-table-column> -->

        <el-table-column prop="type" label="类型/行业" width="200">
          <template slot-scope="{ row }">
            <div v-if="row.typeName" class="margin5px"> <el-tag type="info">{{ row.typeName }}</el-tag></div>
            <div v-if="row.businessName" class="margin5px"><el-tag  type="info">{{ row.businessName }}</el-tag></div>
            <div v-if="row.subBusinessName" class="margin5px"><el-tag  type="info">{{row.subBusinessName}}</el-tag></div>

          </template>
        </el-table-column>
        <el-table-column prop="job" label="职位" width="130">
          <template slot-scope="{ row }">
            <span v-if="$store.state.btn_if.indexOf('user_guest_remark') == -1"> {{ row.job }}</span>
            <Remark
                v-else
                rowKey="job"
                :row="row"
                url="/admin/UserGuest/editInfo"
                @getlist="getlist(row)"
            ></Remark>
          </template>
        </el-table-column>
        <el-table-column prop="jobLevelName" label="级别" width="140">
           <template #header>
                        <span style="display: inline-flex; align-items: center;">
                            <img style="width: 20px; height: 20px; margin-right: 4px;"
                                src="https://cdn-img.yfchuhai.com/www.yfchuhai.com/static/pc/img/ai-icon.png" alt="">
                            级别
                        </span>
                    </template>
          <template slot-scope="{ row }">
            <el-select v-model="row.jobLevel" @change="S_jobLevel(row)">
              <el-option
                  v-for="(item, index) in $store.state.config.userJobLevel"
                  :key="index"
                  :label="item"
                  :value="index * 1"
              />
            </el-select>
          </template>
        </el-table-column>


        <el-table-column prop="remark" label="备注" width="140" >
          <template slot-scope="{ row }">
            <!-- <div class="input-box">
                <el-input v-show="row.pai" v-model="row.remark" size="small" class="id" :autofocus="row.pai" @blur="handleInputBlur(row)" />
            </div>
            <span v-show="!row.pai" @click="$store.state.btn_if.indexOf('user_guest_remark') != -1 && showinput(row)"> {{ row.remark }}</span>
            <i
                v-show="!row.pai"
                :class="$store.state.btn_if.indexOf('user_guest_remark') != -1 && 'el-icon-edit'"
                @click="$store.state.btn_if.indexOf('user_guest_remark') != -1 && showinput(row)"
            /> -->
            <Remarks
                v-if="$store.state.btn_if.indexOf('user_guest_remark') != -1"
                :row="row"
                url="/admin/UserGuest/editRemark"
                @getlist="getlist"
                :val="{ url: '/admin/UserGuest/editRemark', pw: 'user_guest_remark', user:'是否将备注同步至微信会员和高管库' }"

            ></Remarks>
            <span v-else>{{ row.remark }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="activityName" label="活动"> </el-table-column> -->
        <el-table-column prop="waId" label="小助手" width="120">
          <template slot-scope="{ row }">
            <el-select
                v-model="row.waId"
                placeholder="小助手"
                multiple
                :multiple-limit="3"
                size="medium"
                :disabled="!QX('overseas_assistant')"
                @change="chagne(row)"
                @visible-change="visibleChange"
                @remove-tag="handleRemove"
            >
              <el-option
                  v-for="item in $store.state.NormalList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id + ''"
              />
            </el-select>
          </template>
        </el-table-column>

        <el-table-column label="最近更新" width="250">
          <template slot-scope="{ row }">
            <p v-if="row.updateTime">最近更新：{{ row.updateTime  }}</p>
            <p v-if="row.completeInfoTime">完善时间：{{ row.completeInfoTime  }}</p>
            <p v-if="row.createTime">添加时间：{{ row.createTime   }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="活动" width="210">
          <template slot-scope="{ row }">
            <el-tag
                v-for="item in !!row.activityName && row.activityName.split(',')"
                :key="item"
                type="info"
                size="mini"
                effect="dark"
            >{{ item }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" >
          <template slot-scope="ew">
            <router-link :to="'/user_guest_edit?id=' + ew.row.id">
              <el-button
                  v-show="$store.state.btn_if.indexOf('overseas_edit') != -1"
                  type="text"
                  icon="el-icon-edit"
                  size="mini"
                  class="skyblue"
                  @click="edit(ew.row.id)"
              >编辑</el-button
              >
            </router-link>
            <el-button
                v-show="$store.state.btn_if.indexOf('overseas_del') != -1"
                type="text"
                icon="el-icon-delete"
                size="mini"
                class="red"
                @click="open(ew.row.id, 3, ew.row)"
            >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog title="信息" :visible.sync="showinfo" width="40%" @close="infodailog">
      <el-form ref="form" :model="form_show" label-width="80px" :inline="false" size="normal">
        <el-form-item label="手机号">
          <!-- <el-input v-model="form_show.phone"></el-input> -->
          <span>{{ form_show.phone }}</span>
        </el-form-item>
        <el-form-item label="邮箱">
          <!-- <el-input v-model="form_show.email"></el-input> -->
          <span>{{ form_show.email }}</span>
        </el-form-item>
        <el-form-item label="企业邮箱">
          <!-- <el-input v-model="form_show.businessEmail"></el-input> -->
          <span>{{ form_show.businessEmail }}</span>
        </el-form-item>
        <el-form-item label="微信">
          <!-- <el-input v-model="form_show.wechat"></el-input> -->
          <span>{{ form_show.wechat }}</span>
        </el-form-item>
      </el-form>
    </el-dialog>
    <pop ref="pop" title="将根据手机号从注册会员数据中同步备注和小助手到内部会员" @toAudit="toSync">
      <el-radio v-model="registeringSynchronization" :label="1">将注册会员信息完全覆盖到内部会员</el-radio>
      <br /><br />
      <el-radio v-model="registeringSynchronization" :label="2">只覆盖内部会员数据为空的字段</el-radio>
    </pop>
    <helperStatistics ref="helperStatistics"></helperStatistics>
    <send-sms ref="sendSms" type="3"></send-sms>
  </div>
</template>

<script>
import log from "@/views/activity/activity_speaker_ppt/log.vue";

let that;

import $ from "jquery";
// import rules from '../../utils/rules'
import show from "../../components/countDowns/show.vue";
import { editInfo } from "../../api/upload.model.js";
import improvePersonnel from "../guest/component/improve-personnel";
import helperStatistics from "../guest/component/helperStatistics.vue";
import Remarks from "@/components/remark/index.vue";
import { fetchEnterpriseTypeList, fetchEnterpriseBusinessList } from "@/utils/methods";
export default {
  components: {
    Show: show,
    improvePersonnel,
    helperStatistics,
    Remarks
  },
  filters: {
    // Ftype(val) {
    //   return that.$store.state.config.user_type[val]
    // },

    getarea: function(value) {
      // console.log(that.area.reportArea,value);
      if (that.area.reportArea) {
        var reportArea = that.area.reportArea[value];
        return reportArea;
      }
    },
    getbu(value) {
      if (that.area.reportBusiness) {
        var reportBusiness = that.area.reportBusiness[value];
      }
      return reportBusiness;
    },
    getviewType(val) {
      if (val == 1) {
        return "在线查看";
      } else {
        return "下载";
      }
    },
  },
  data() {
    return {
      isDerive:false,
      row:{},
      phonelist: [],
      registeringSynchronization: 2,
      total_form: {
        allTotal: 0,
        existPhoneTotal: 0,
        emptyPhoneTotal:0,
        totalCount:0

      },
      importExcel: false,
      proof: false,
      reveal: true,
      table: [],
      impEX: "导入Excel",
      dioA: false,
      showinfo: false,
      date: [],
      title: "",
      year: "",
      publishStatus: "",
      reportArea: "",
      reportBusiness: "",
      order: "",
      confing: "",
      btn: true,
      action: {
        action: "report",
      },
      dioaddkuai: false,
      currentPage: 1,
      pagesize: 10,
      list: [],
      pai: [],
      paiform: {},
      value: "",
      dialogVisible: false,
      dialogVisiblexui: false,
      baseurl: this.$store.state.env.cdnStatic,
      yu: "/" + this.$store.state.env.domain,
      total: 0,
      form: {
        title: "",
        source: "",
        picture: "",
        content: "",
        desc: "",
        areaCode: "",
        banner: "",
        viewType: "",
        businessId: "",
      },
      form_1: {
        id: "",
        title: "",
        source: "",
        picture: "",
        content: "",
        desc: "",
        areaCode: "",
        banner: "",
        viewType: "",
        businessId: "",
      },
      category:[5],
      form_2: {
        company:"",
        category:'5',
        page: 1,
        pageSize: 10,
        keyword: "",
        waId: "",
        business: "",
        city: "",
        type: "",
        amId: "",
        bindEnterprise: "",
        completeTime: [],
        createTime: [],
        jobLevel:[],
        updateTime:[],
        subBusiness: "",
        register:'',
        completeInfo:''
        // order: ''
      },
      form_3: {
        phone: "15810051960",
        smsCode: "",
      },
      imageUrl: "",
      imageUrl_1: "",
      timeout: null,
      header: {
        Token: sessionStorage.getItem("token"),
      },
      form_show: {},
      area: [],
      p_arr: [],
      c_arr: [],
      total2: 1,
      currentPage2: 1,
      phone_data: false,
      state_a: false,
      typeList: [],
      businessList: [],
      subBusinessList: [],
      syncEnterpriseLoad: false,
    };
  },
  computed: {
    // Fbusiness() {
    //   return function(row) {
    //     return (
    //       this.$store.state.config.user_business[row.type] &&

    //       this.$store.state.config.user_business[row.type][row.business]
    //     )
    //   }
    // },
    jobLevel() {
      return function(row) {
        return this.$store.state.config.userJobLevel[row.jobLevel];
      };
    },
    QX() {
      return function(val) {
        return this.$store.state.btn_if.indexOf(val) != -1;
      };
    },
  },
  beforeCreate() {
    that = this;
  },
  destroyed() {
    clearInterval(this.timeout);
  },
  created() {
    let data = JSON.parse(sessionStorage.getItem('menu'))
    if(data.find(item=>item.name == 'user_manage').children.find(item=>item.name == 'inside').children.find(item=>item.name == 'export_user_data')){
      this.isDerive=true

    }
    // sessionStorage.setItem('action', 'report')
    this.getp();
    this.getlist()
  },
  mounted() {
    this.timeout = setInterval(() => {
      var ifs = JSON.parse(sessionStorage.getItem("adf"));
      // console.log(ifs)
      if (ifs) {
        this.phone_data = !this.phone_data;
        sessionStorage.setItem("adf", false);
        // console.log(this.$store.state.Did)
        this.getphoneid({
          id: this.$store.state.Did,
        });
        this.getlist();
        this.get_data();
      } else {
        if (this.$store.state.counts < 1) {
          this.getlist();
          this.get_data();
          this.$store.state.counts++;
        } else {
          clearInterval(this.timeout);
        }
      }
    }, 1000);
    this.getType();
  },
  watch: {
    "form_2.business"(newValue, oldValue) {
      this.form_2.subBusiness = "";
      if (newValue !== '' && newValue != null && newValue !== -1) {
        this.getType("2");
      } else {
        this.subBusinessList = [];
      }
    },
  },
  activated() {
    this.getlist();
  },
  methods: {
    infodailog(){
      this.form_show={}
    },
    handleDerived(){
      const data = {
        form:this.form_2,
        type:2,
        category:this.category,
      }
      this.$router.push(
          {
            path:'/export_user_data',
            query:{
              data:JSON.stringify(data.form),
              category:JSON.stringify(data.category),
              type:data.type
            }
          }
      )
    },
    async syncEnterprise() {
      await this.$confirm("是否同步企业信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      });
      try {
        this.syncEnterpriseLoad = true;
        let { data } = await this.$http.post("/admin/UserGuest/syncEnterprise");
        this.syncEnterpriseLoad = false;
      } catch (error) {
        this.syncEnterpriseLoad = false;
      }
    },
    async solutionEnterprise(row) {
      try {
        await this.$confirm("是否解绑企业?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        const { data: res } = await this.$http.post("/admin/UserGuest/unBindEnterprise", { id: row.id });
        if (res.errorCode == 200) {
          this.$message.success(res.message);
          this.getlist();
        }
      } catch (error) {}
    },
    async onDownload() {
      const { data: res } = await this.$http.get("/admin/UserGuest/downloadTemplate");
      location.href=res.data.url
      // location.href = "https://admin.yfchuhai.com/xlsx/tpl.xlsx";
    },
    reset() {
      // console.log();
      this.category=[]
      this.form_2 = this.$options.data.call(this).form_2;
      this.subBusinessList = [];
      this.currentPage = 1;
      this.currentPage2 = 1;
      this.getlist();
      this.reveal = true;
    },
    fEnterpriseId(val) {
      if (val.enterpriseId > 0) {
        return "已绑定";
      }
      return "未绑定";
    },
    handleCurrentChange2(e) {
      this.currentPage2 = e;
      this.get_data();
    },
    fUser(row) {
      if (this.$toData(row.user)) {
        if (row.user.certStatus == 2) {
          return "已认证";
        }
        if (row.user.completeInfo == 1) {
          return "已完善";
        }
        return "已注册";
      }
      return "";
    },
    fUserColor(row) {
      if (this.$toData(row.user)) {
        if (row.user.certStatus == 2) {
          return "success";
        }
        if (row.user.completeInfo == 1) {
          return "";
        }
        return "warning";
      }
      return "";
    },
    showinput(row, val) {
      row.pai = true;
      if (val == 2) {
        this.table = [...this.table];
      } else if (val == 3) {
        this.phonelist = [...this.phonelist];
      } else {
        this.list = [...this.list];
      }
      setTimeout(() => {
        $(".id input").focus();
      }, 20);
    },
    showinput_1(row, val) {
      row.pai_1 = true;
      if (val == 2) {
        this.table = [...this.table];
      } else if (val == 3) {
        this.phonelist = [...this.phonelist];
      } else {
        this.list = [...this.list];
      }
      setTimeout(() => {
        $(".id input").focus();
      }, 20);
    },
    handleInputBlur(row, val) {
      this.$http.post("/admin/UserGuest/editRemark", row).then(({ data: res }) => {
        if (res.errorCode == 200) {
          this.$message.success(res.message);
          if (val == 2) {
            this.get_data();
          } else if (val == 3) {
            this.getphoneid(row);
          } else {
            this.getlist();
          }
        }
      });
    },
    async Stype(row, val) {
      const res = await editInfo({
        ...row,
        type: row.type.toString(),
      });
      if (res.errorCode == 200) {
        this.$message.success(res.message);
        if (val == 2) {
          this.get_data();
        } else if (val == 3) {
          this.getphoneid(row);
        } else {
          this.getlist();
        }
      }
    },
    async Sbusiness(row, val) {
      const res = await editInfo({
        ...row,
        business: row.business.join(","),
      });
      if (res.errorCode == 200) {
        this.$message.success(res.message);
        if (val == 2) {
          this.get_data();
        } else if (val == 3) {
          this.getphoneid(row);
        } else {
          this.getlist();
        }
      }
    },
    async toSync() {
      let { data: res } = await this.$http.post("/admin/UserGuest/sync", {
        type: this.registeringSynchronization,
      });
      if (res.errorCode == 200) {
        this.$message.success(res.message);
        this.$refs.pop.show = false;
        this.reset();
      }
    },
    handleInputBlur_1(row, val) {
      this.$http.post("/admin/UserGuest/editInfo", row).then(({ data: res }) => {
        if (res.errorCode == 200) {
          this.$message.success(res.message);
          if (val == 2) {
            this.get_data();
          } else if (val == 3) {
            this.getphoneid(row);
          } else {
            this.getlist();
          }
        }
      });
    },
    show_ex(row) {
      this.phone_data = true;
      setTimeout(() => {
        this.getphoneid(row);
      }, 200);
    },
    async getphone(row) {
      // var that=this
      console.log(row);
      const { data: res } = await this.$http.get("/admin/UserGuest/getListByPhone", {
        params: {
          phone: row.phone,
        },
      });

      if (res.errorCode == 200) {
        // Vue.set(this.phonelist, index, res.data.list)
        this.phonelist = [...res.data.list];
        this.phonelist.forEach((item) => {
          if (item.waId.length > 0) {
            item.waId = item.waId.split(",");
          }
        });
        // this.data.phonelist = res.data.list
        // that.$set('phonelist',res.data.list)
        // console.log(this.phonelist);
      }
    },
    show_s() {
      this.reveal = !this.reveal;
      this.get_data();
    },
    async get_data() {
      const { data: res } = await this.$http.get("/admin/UserGuest/getRedundantList", {
        params: {
          page: this.currentPage2,
          pageSize: 10,
        },
      });
      if (res.errorCode == 200) {
        this.table = res.data.list;
        this.total2 = res.data.totalCount;
        this.table.forEach((item) => {
          if (item.waId.length > 0) {
            item.waId = item.waId.split(",");
          }
          if (item.business.trim().length > 0) {
            item.business = item.business.split(",");
          } else {
            item.business = [];
          }
          if (item.type == 0) {
            item.type = "";
          } else {
            item.type = item.type.toString().split(",");
          }
          // if (item.jobLevel == 0) {
          //     item.jobLevel = ''
          // }
        });
      }
    },
    Import(val) {
      var that = this;
      if (this.impEX == "导入Excel") {
        const input = document.createElement("input");
        input.type = "file";
        input.accept = ".xlsx";

        input.click();
        input.onchange = function() {
          // console.log(this.files[0])
          var file = this.files[0];
          var formData = new FormData();
          formData.append("file", file);
          var url;
          if (val == "new") {
            url = "/admin/UserGuest/importExcelNew";
            that.importExcel = true;
          } else {
            url = "/admin/UserGuest/importExcel";
          }
          that.$http.post(url, formData).then(({ data: res }) => {
            if (res.errorCode == 200) {
              that.$message.success(res.message);
            } else {
              that.$message.error(res.message);
            }
            if (val != "new") {
              that.impEX = "导入Excel";
            } else {
              that.importExcel = false;
            }
          });
          if (val != "new") {
            that.impEX = "导入中";
          }
        };
      }
    },
    async getp() {
      const jj = await this.$store.dispatch("getProvince");
      this.p_arr = jj.data;
    },
    async getc(val) {
      this.form_2.city = "";

      const jj = await this.$store.dispatch("getCity", val);
      if (jj.errorCode == 200) {
        this.c_arr = jj.data;
      }
    },
    subimt() {
      this.currentPage = 1;
      this.form_2.page = 1;
      this.form_2.category=this.category.join(',')
      this.getlist();
      this.reveal = true;
    },
    check() {
      console.log(1);
    },
    information(row) {
      // this.form_show = row
      this.$http
          .get("/admin/UserGuest/getById?id", {
            params: {
              id: row.id,
            },
          })
          .then(({ data: res }) => {
            if (res.errorCode == 200) {
              this.form_show = res.data;
              this.showinfo = true;
            }
          });


    },
    datum(row) {
      if (!row.document) {
        this.$message.error('当前暂无文件！')
        return
      }
      location.href = this.baseurl + this.yu + row.document
    },
    sortChange(c) {
      console.log(c);
      if (c.order) {
        var s = "activity_" + c.prop;
        if (c.prop == "orderNum") {
          s = "report_order_num";
        } else if (c.prop == "views") {
          s = "report_views";
        } else {
          s = "report_" + c.prop;
        }
        var p = c.order.slice(0, c.order.length - 6);
        this.order = s + " " + p;
      } else {
        this.order = "";
      }

      this.getlist();
    },

    addkuai() {
      this.addkuai = false;
    },
    getea() {
      this.$http.get("/admin/ReportCategory/getList").then(({ data: res }) => {
        if (res.errorCode == 200) {
          this.area = res.data;
        }
      });
    },
    rowClass() {
      return "background:#F5F7FA;";
    },
    handleSizeChange(e) {
      this.pagesize = e;
      console.log(e);
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.form_2.page = e;
      this.getlist();
    },
    getlist() {
      this.$http
          .get("/admin/UserGuest/getList", {
            params: {
              ...this.form_2,
              jobLevel:this.form_2.jobLevel.join(","),
              completeTime: this.form_2.completeTime.join("~"),
              createTime: this.form_2.createTime.join("~"),
              updateTime:this.form_2.updateTime.join("~"),
            },
          })
          .then(({ data: res }) => {
            if (res.errorCode == 200) {
              // console.log(res)
              this.list = res.data.list;
              this.total = res.data.totalCount;
              this.total_form.allTotal = res.data.allTotal ? res.data.allTotal : 0;
              this.total_form.existPhoneTotal = res.data.existPhoneTotal;
              this.total_form.totalCount=res.data.totalCount;
              this.total_form.emptyPhoneTotal=res.data.emptyPhoneTotal;
              this.list.forEach((item) => {
                if (item.waId.length > 0) {
                  item.waId = item.waId.split(",");
                }
                if (item.business.trim().length > 0) {
                  item.business = item.business.split(",");
                } else {
                  item.business = [];
                }
                // if(item.business.trim().length>0)
                if (item.type == 0) {
                  item.type = "";
                } else {
                  item.type = item.type.toString().split(",");
                }
                // if (item.jobLevel == 0) {
                //     item.jobLevel = ''
                // }
              });
              // console.log(this.list)
              


              // this.getarea()
              this.list.forEach((item) => {
                this.pai.push({
                  id: item.id,
                  pai: false,
                });
              });
              // this.getea()
            }
          });
    },
    checkf(val) {
      this.form_3 = val;
      // console.log(this.form_3)
    },
    async beforedown() {
      // const phone = this.$cookies.get('phone')
      const phone = "15810051960";
      if (!phone) {
        this.$message.error("没有绑定手机号");
        return;
      }
      if (!this.proof) {
        this.dioA = true;
      } else {
        this.download();
      }
    },
    async download(val) {
      if (this.btn) {
        this.btn = false;
        // const { data: res } = await this.$http.get(
        //   '/admin/Common/checkSmsCode',
        //   {
        //     params: {
        //       ...this.form_3
        //     }
        //   }
        // )
        console.log(val);
        // console.log(this.btn)
        // this.$forceUpdate()
        if (false) {
          // this.$message.error(res.message)
          // return
        } else {
          const { data: res } = await this.$http.get("/admin/UserGuest/exportExcel", {
            params: {
              ...this.form_2,
              ...this.form_3,
            },
          });
          // console.log();
          if (res.errorCode == 200) {
            this.proof = true;
          }

          // console.log(1);
          this.btn = true;

          // console.log(msg.data.url);
          // let url = window.URL.createObjectURL(msg.data) //表示一个指定的file对象或Blob对象
          // console.log(url,"看一下这是啥")
          // let a = document.createElement('a')
          // document.body.appendChild(a)
          // console.log(msg.data)
          // let url = msg.data.url
          // console.log(url)
          if (res.errorCode == 200) {
            this.$message.success(res.message);
            location.href = res.data.url;
            this.dioA = false;
          }
          // a.href = url
          // a.download //命名下载名称
          // a.click() //点击触发下载
          // window.URL.revokeObjectURL(url)
          // this.dioA = false
        }
      }
    },
    add() {},
    handleAvatarSuccess(res, file) {
      if (res.errorCode == 200) {
        this.form.banner = res.data.url;
      }
      console.log(file);
      //   console.log(imgurlbase)
    },

    // beforeAvatarUpload(file) {
    //   const isJPG = file.type === 'image/jpeg'
    //   const isLt2M = file.size / 1024 / 1024 < 2

    //   if (!isJPG) {
    //     this.$message.error('上传头像图片只能是 JPG 格式!')
    //   }
    //   if (!isLt2M) {
    //     this.$message.error('上传头像图片大小不能超过 2MB!')
    //   }
    //   return isJPG && isLt2M
    // },
    handleAvatarSuccess_1(res, file) {
      if (res.errorCode == 200) {
        this.form_1.banner = res.data.url;
      }
      console.log(file);
      //   console.log(imgurlbase)
    },
    beforeAvatarUpload_1(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },

    addedit() {
      if (this.btn) {
        // this.form.picture = this.form.picture.slice(this.baseurl.length)

        this.$http.post("/admin/News/edit", this.form_1).then(({ data: res }) => {
          if (res.errorCode == 200) {
            this.dialogVisiblexui = false;
            this.$message.success(res.message);
            this.getlist();
          }
          this.btn = true;
        });
      }
      this.btn = false;
    },
    edit(id) {
      var qq = document.querySelector(".v-modal");
      if (qq) {
        this.phone_data = false;
      }
    },
    S_jobLevel(row, val) {
      this.$http
          .post("/admin/UserGuest/editInfo", {
            id: row.id,
            jobLevel: row.jobLevel,
          })
          .then(({ data: res }) => {
            if (res.errorCode == 200) {
              this.$message.success(res.message);
              if (val == 2) {
                this.get_data();
              } else if (val == 3) {
                this.getphoneid(row);
              } else {
                this.getlist();
              }
            }
          });
    },
    open(id, val, row) {
      this.$confirm("此操作将永久删除该, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {
            this.$http
                .delete("/admin/UserGuest/del", {
                  params: {
                    id: id,
                  },
                })
                .then((res) => {
                  //   console.log(res)
                  if (res.data.errorCode == 200) {
                    this.$message({
                      type: "success",
                      message: "删除成功!",
                    });
                    if (this.total % 10 == 1) {
                      this.form_2.page--;
                    }
                    if (val == 1) {
                      this.getlist();
                    } else {
                      this.get_data();
                      this.getlist();
                      this.getphoneid(row);
                    }
                  }
                });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
    },
    getphoneid(val) {
      this.$http
          .get("/admin/UserGuest/getListById", {
            params: {
              id: val.id,
            },
          })
          .then(({ data: res }) => {
            if (res.errorCode == 200) {
              this.phonelist = res.data.list;
              this.phonelist.forEach((item) => {
                if (item.waId.length > 0) {
                  item.waId = item.waId.split(",");
                }
                if (item.business.trim().length > 0) {
                  item.business = item.business.split(",");
                } else {
                  item.business = [];
                }
                if (item.type == 0) {
                  item.type = "";
                } else {
                  item.type = item.type.toString().split(",");
                }
                // if (item.jobLevel == 0) {
                //     item.jobLevel = ''
                // }
              });
            }
          });
    },
    async loadEnterpriseTypeList() {
      this.typeList = await fetchEnterpriseTypeList(this.$http);
    },
    async loadEnterpriseBusinessList() {
      this.businessList = await fetchEnterpriseBusinessList(this.$http);
    },
    async getType(val) {
      if (val == 2) {
        var { data: res } = await this.$http.get(
            `/admin/EnterpriseCategory/getList?keyword=&page=1&pageSize=100&order=&businessId=${this.form_2.business}`
        );
        this.subBusinessList = res.data.list;
        return;
      }
      await this.loadEnterpriseTypeList();
      await this.loadEnterpriseBusinessList();
    },
    unfold(val) {
      this.phone_data = true;
      this.getphoneid(val);
    },
    show(id, el) {
      this.$http
          .post("/admin/Report/publish", {
            id: id,
            publishStatus: el,
          })
          .then(({ data: res }) => {
            if (res.errorCode == 200) {
              this.$message.success(res.message);
              this.getlist();
            }
          });
    },
    handleRemove(){
      this.$confirm('是否确定删除？', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(() => {
        this.visibleChange()
      }).catch(() => {
        this.getlist()

      });
    },
    visibleChange(e){
      if(e){
        return
      }else {
        this.$confirm('是否将小助手同步至注册用户', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning'
        }).then(() => {
          this.$http
              .post("/admin/UserGuest/editService", {
                ...this.row,
                waId: this.row.waId.join(","),
                sync: 1
              })
              .then(({ data: res }) => {
                if (res.errorCode == 200) {
                  this.getlist();
                } else {
                  this.getlist();
                }
              });

        }).catch(() => {
          this.$http
              .post("/admin/UserGuest/editService", {
                ...this.row,
                waId: this.row.waId.join(","),
                sync: 0
              })
              .then(({ data: res }) => {
                if (res.errorCode == 200) {
                  this.getlist();
                } else {
                  this.getlist();
                }
              });

        });

      }

    },

    chagne(row, val) {
      this.row=row
      if(val==3){
        this.$http
            .post("/admin/UserGuest/editService", {
              ...row,
              waId: row.waId.join(","),
            })
            .then(({ data: res }) => {
              if (res.errorCode == 200) {
                if (val == 3) {
                  this.getphoneid(row);
                } else {
                  this.getlist();
                }
              } else {
                if (val == 3) {
                  this.getphoneid();
                } else {
                  this.getlist();
                }
              }
            });

      }


    },
  },
};
</script>

<style lang="less" scoped>
.flex-center{
  display: flex;
  align-items: center;
  text-align: center;
}
.out {
  // width: 500px;

  margin-bottom: 20px;

  .input {
    width: 37%;
    height: 36px;
    display: inline-block;
    margin-right: 30px;
  }
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.skyblue {
  color: skyblue;
}

.green {
  color: green;
}

.yellow {
  color: pink;
}

.red {
  color: red;
}

.out .input {
  width: 18%;
}
.out .input

.el-card {
  position: relative;
}

.out .right {
  float: right;
}

.out_sp {
  display: inline-block;
  margin-right: 10px;
}
.margin5px{
  margin: 5px 0;
}
</style>
